// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';
import { DropdownManager } from './dropdown-manager';
import { prepareUrl, isRtl } from './common';

/**
 * @class Jsw.ListContextMenu
 * @extends Jsw.Container
 */
export const ListContextMenu = Class.create(Container, {
    TARGET_TYPE_DROP_DOWN: 'dropDown',
    TARGET_TYPE_TABLE_ROW: 'tableRow',

    _initConfiguration($super, config) {
        $super(config);

        this._cls = 'popup-box popup-menu collapsed';
        this._list = this._getConfigParam('list');
    },

    _initComponentElement($super) {
        $super();

        this._componentElement.update(
            '<table class="popup-wrapper" cellspacing="0"><tbody><tr><td class="popup-container">' +
                '<div class="c1"><div class="c2"><div class="c3"><div class="c4"><div class="c5">' +
                    '<div class="popup-content">' +
                        '<div class="popup-content-area"></div>' +
                    '</div>' +
                '</div></div></div></div></div>' +
            '</td></tr></tbody></table>'
        );
    },

    /**
     * Called on list redraw
     */
    onRedraw() {
        this._initRowStyles();
        this._initShowOnClick();
    },

    /**
     * Get list of actions for popup by row
     */
    _prefillPopup(row) {
        let contentArea = this._componentElement.down('.popup-content-area').update('<ul></ul>');
        contentArea = contentArea.down('ul');
        row.actions.each(function (actionInfo) {
            if (actionInfo === 'separator') {
                contentArea.insert('<li class="separator"><span></span></li>');
                return;
            }
            if (typeof actionInfo === 'string') {
                actionInfo = { name: actionInfo };
            }
            const item = new Element('li').update(
                '<a' +
                    ` class="sb-btn ${actionInfo.iconClass ? actionInfo.iconClass : 'sb-no-icon'}"` +
                    ` href="${actionInfo.href ? prepareUrl(actionInfo.href) : '#'}"` +
                    `${actionInfo.newWindow ? ' target="_blank"' : ''}` +
                    ` data-button-key="${actionInfo.name}"` +
                    `${actionInfo.onclick ? ` onclick="${actionInfo.onclick}"` : ''}` +
                '>' +
                    '<i><i><i>' +
                        `<span>${actionInfo.title || this._list.lmsg(`item-action-${actionInfo.name}`)}</span>` +
                    '</i></i></i>' +
                '</a>'
            );

            if (this._list._itemActions && this._list._itemActions[actionInfo.name]) {
                item.down('a').observe('click', function (event) {
                    event.preventDefault();
                    this._list._itemActions[actionInfo.name](row, event);
                }.bind(this));
            }

            contentArea.insert(item);
        }, this);
    },

    /**
     * Show prefilled popup on context menu button click
     */
    _togglePopupNearButton(button) {
        $(this._list._tableId).select('tr.odd,tr.even').each(function (el) {
            el.removeClassName('row-over');
        });
        this._componentElement.addClassName('collapsed');

        if (!button.up('.btn-group').hasClassName('btn-group-open')) {
            $$('.btn-list-menu').each(function (el) {
                el.up('.btn-group').removeClassName('btn-group-open');
            });

            this._componentElement.removeClassName('collapsed');
            button.up('tr').addClassName('row-over');
        }

        button.up('.btn-group').toggleClassName('btn-group-open');

        const scrollOffsets = document.viewport.getScrollOffsets();
        const buttonPosition = button.viewportOffset();
        buttonPosition.left += scrollOffsets.left;
        buttonPosition.top += scrollOffsets.top;

        const buttonWidth = button.getWidth();
        const buttonHeight = button.getHeight();

        if (!this._componentElement.hasClassName('collapsed')) {
            this._setPosition(
                buttonPosition.left,
                buttonPosition.top + buttonHeight,
                buttonPosition.left + buttonWidth,
                buttonPosition.top
            );
        }
    },

    _initRowStyles() {
        $(this._list._tableId).select('tr.odd,tr.even').each(function (el) {
            const button = el.down('.dropdown-toggle');
            if (!button) {
                return;
            }

            const row = this._list.getItemById(button.readAttribute('data-row-id'));
            if (!row || !row.actions || !row.actions.length) {
                return;
            }

            el.addClassName('list-context-actions');
        }, this);
    },

    /**
     * Hide popup and remove selection from row
     */
    _hidePopup() {
        this._componentElement.addClassName('collapsed');
        this.targetData.rowEl.down('.btn-group').removeClassName('btn-group-open');
        this.targetData.rowEl.removeClassName('row-over');
    },

    _openPopup(event) {
        this._prefillPopup(this.targetData.rowData);
        if (this.targetType === this.TARGET_TYPE_TABLE_ROW) {
            this.targetData.rowEl.addClassName('row-over');
            this._componentElement.removeClassName('collapsed');
            this._setPosition(Event.pointerX(event), Event.pointerY(event));
        } else {
            this._togglePopupNearButton(this.targetData.dropDownEl);
        }
    },

    _isListContextEvent({ target }) {
        return (!(target.match('input,a') || target.up('a'))
            && (target.match('.list-menu')
                || target.up('.list-menu')
                || target.match('[data-row-id]')
                || target.up('[data-row-id]')
            )
        );
    },

    _getTargetData(target) {
        const rowEl = target.up('tr');
        let dropDownEl;

        if (this.targetType === this.TARGET_TYPE_DROP_DOWN) {
            dropDownEl = target.up('.btn-list-menu');
        } else
        if (this.targetType === this.TARGET_TYPE_TABLE_ROW) {
            dropDownEl = rowEl.down('.dropdown-toggle');
        }
        if (!dropDownEl) {
            return null;
        }

        const rowData = this._list.getItemById(dropDownEl.readAttribute('data-row-id'));
        if (rowData && rowData.actions && rowData.actions.length) {
            return {
                rowData,
                rowEl,
                dropDownEl,
            };
        }

        return null;
    },

    _getTargetType(target) {
        if (target.match('.list-menu') || target.up('.list-menu')) {
            return this.TARGET_TYPE_DROP_DOWN;
        } else
        if (target.match('[data-row-id]') || target.up('[data-row-id]')) {
            return this.TARGET_TYPE_TABLE_ROW;
        }

        return null;
    },

    _open(event) {
        this.targetType = this._getTargetType(event.target);
        this.targetData = this._getTargetData(event.target);

        if (!this.targetData) {
            return;
        }

        this._openPopup(event);
    },

    _hide(event) {
        if (!this.targetData) {
            return;
        }

        this._hidePopup(event);

        if (this._isListContextEvent(event) && this._isImmediatelyOpening(event)) {
            this._open(event);
        }
    },

    _isOpened() {
        return (
            (
                this.targetData
                && this.targetData.dropDownEl
                && this.targetData.dropDownEl.up('.btn-group').hasClassName('btn-group-open')
            )
            || !this._componentElement.hasClassName('collapsed')
        );
    },

    _isImmediatelyOpening(event) {
        const targetType = this._getTargetType(event.target);
        const targetData = this._getTargetData(event.target);

        return (targetType && targetData
            && ((targetType === this.TARGET_TYPE_DROP_DOWN && this.targetType === this.TARGET_TYPE_TABLE_ROW)
                || (targetType === this.TARGET_TYPE_DROP_DOWN
                && targetData.rowEl.readAttribute('data-row-id') !== this.targetData.rowEl.readAttribute('data-row-id'))
            )
        );
    },

    /**
     * Show popup on click row or dropdown button
     */
    _initShowOnClick() {
        DropdownManager.register(
            $(this._list._tableId),
            this._isOpened.bind(this),
            this._open.bind(this),
            this._hide.bind(this),
            this._isListContextEvent.bind(this)
        );
    },

    _setPosition(x, y, altX, altY) {
        altX = altX || x;
        altY = altY || y;

        const scrollOffsets = document.viewport.getScrollOffsets();

        const windowWidth = $(document.body).getWidth();
        const popupWidth = this._componentElement.getWidth();
        if (isRtl()) {
            if ((altX - popupWidth - scrollOffsets.left) > 0) {
                x = altX - popupWidth;
            }
        } else if ((x + popupWidth - scrollOffsets.left) > windowWidth) {
            x = altX - popupWidth;
        }

        const windowHeight = $(document.body).getHeight();
        const popupHeight = this._componentElement.getHeight();
        const popupMarginTop = parseInt(this._componentElement.getStyle('margin-top'));
        if ((y + popupHeight + popupMarginTop - scrollOffsets.top) > windowHeight) {
            y = altY - popupHeight - (2 * popupMarginTop);
        }

        this._componentElement.setStyle({
            right: 'auto',
            left: `${x}px`,
            top: `${y}px`,
        });
    },
});



// WEBPACK FOOTER //
// ./jsw/list-context-menu.js